import { createContext } from "react";
import { User } from "../models/responses";

export type AuthContextType = {
    user: User | null;
    login: (data: User) => void;
    logout: () => void;
};

const defaultAuthContext: AuthContextType = {
    user: null,
    login: () => {},
    logout: () => {},
};

export const AuthContext = createContext<AuthContextType>(defaultAuthContext);
